<template>
  <article id="article-fund-ranking" sticky-container>
    <modal-slide-up v-if="isFilter" @close-modal="toggleFilter">
      <h3 slot="header"></h3>
      <div slot="body">
        <div class="filter-body">
          <h2>ตัวกรองการค้นหา</h2>
          <div class="filter-row">
            <dropdown
              v-if="getFundCategories && getFundCategories.length > 0"
              :arrDropdown="getFundCategories"
              :alias="`category`"
              :defaultItem="defaultCategory"
              :placeholder="`All Category`"
              data-action="filter_fund_category"
              @select-data="prepareQs"
              :enableFade="true"
            />
          </div>
          <div class="filter-row">
            <dropdown
              v-if="getFundAmc && getFundAmc.length > 0"
              :arrDropdown="getFundAmc"
              :alias="`amc`"
              data-action="filter_fund_amc"
              :defaultItem="defaultAmc"
              :placeholder="`บลจ. ทั้งหมด`"
              @select-data="prepareQs"
              :enableFade="true"
            />
          </div>
          <div class="filter-row">
            <h4>ประเภท</h4>
            <checkbox
              :arrItems="type"
              :str="'ประเภท'"
              :defaultItem="defaultType"
              :alias="'type'"
              @select-data="prepareQs"
            />
          </div>
          <div class="filter-row">
            <h4>เงินปันผล</h4>
            <checkbox :arrItems="dividend" :defaultItem="defaultDividend" :alias="'dividend'" @select-data="prepareQs" />
          </div>
          <div class="filter-submit">
            <a href="javascript:;" data-action="apply_fund_filter" class="ctn-filter" @click="submitFilter">Apply</a>
          </div>
        </div>
      </div>
    </modal-slide-up>
    <section id="section-filter-fund">
      <div class="filter-left">
        <dropdown
          data-action="filter_fund_category"
          v-if="getFundCategories && getFundCategories.length > 0"
          :arrDropdown="getFundCategories"
          :alias="`category`"
          :placeholder="`All Category`"
          :defaultItem="defaultCategory"
          @select-data="insertQs"
        />
      </div>
      <div class="filter-right">
        <a data-action="open_modal_fund_filter" class="filter-ctn" href="javascript:;" @click="toggleFilter">
          <i
            class="fas fa-filter"
            :class="[filterTagsShow.amc && filterTagsShow.amc.length > 0 || filterTagsShow.type && filterTagsShow.type.length > 0 || filterTagsShow.dividend && filterTagsShow.dividend.length > 0 ? 'filtered' : '']"
          ></i>
        </a>
      </div>
    </section>
    <section
      id="section-filter-tags"
      v-if="filterTagsShow.amc && filterTagsShow.amc.length > 0 || filterTagsShow.type && filterTagsShow.type.length > 0 || filterTagsShow.dividend && filterTagsShow.dividend.length > 0"
    >
      <div class="filter-tags-box" @click="toggleFilter">
        <span class="tags-label">Filter:</span>
        <ul class="tags-list">
          <li class="tags-item" :key="`amc`+index" v-for="(item, index) in filterTagsShow.amc">{{ item.title }}</li>
          <li
            class="tags-item"
            :key="`type`+index"
            v-for="(item, index) in filterTagsShow.type"
          >{{ generateText(item) }}</li>
          <li
            class="tags-item"
            :key="`dividend`+index"
            v-for="(item, index) in filterTagsShow.dividend"
          >{{ generateText(item) }}</li>
        </ul>
      </div>
      <a href="javascript:;" data-action="reset_fund_filter" class="reset-filter" @click="resetFilter">
        <i class="fas fa-times-circle"></i>
      </a>
    </section>
    <div :class="[ shouldStick ? 'period-sticky-top' : 'period-remove-sticky-top']">
      <div class="select-period-row">
        <period-navigation
          data-action="change_fund_period"
          :arrPeriod="arrPeriod"
          :alias="`period`"
          @select-data="insertQs"
          :defaultItem="defaultPeriod"
          :slidePerPage="10"
        />
      </div>
    </div>
    <section id="list-fund">
      <list-market
        data-action="open_fund"
        data-list="market_fund"
        :items="getFundFilter"
        v-if="getFundFilter.length"
        :type="'fund'"
        @select-data="insertQs"
        :wantLoaing="true"
      />
    </section>
  </article>
</template>
<script>
import GlobalMarketFunc from "../../../../components/mixins/global-market-functions"
import PeriodNavigation from "../../../../components/miniapp/global/PeriodNavigation.vue"
import Dropdown from "../../../../components/miniapp/global/Dropdown.vue"
import ModalSlideUp from "../../../../components/miniapp/global/ModalSlideUp.vue"
import Checkbox from "../../../../components/miniapp/global/CheckBox.vue"
import ListMarket from "../../../../components/miniapp/market/List"

import { mapGetters, mapActions } from "vuex"
export default {
  components: {
    PeriodNavigation,
    Dropdown,
    ModalSlideUp,
    Checkbox,
    ListMarket
  },
  mixins: [GlobalMarketFunc],
  data() {
    return {
      arrFilterTags: {},
      filterTagsShow: {},
      shouldStick: false,
      objQuery: {},
      prepareObjQuery: {},
      arrDropdown: {
        label: "All Category",
        default: 0,
        data: [
          {
            name: "Category1",
            value: "0"
          },
          {
            name: "Category2",
            value: "0"
          }
        ]
      },
      defaultCategory: "",
      defaultPeriod: "1Y",
      defaultAmc: "",
      arrPeriod: ["1D", "1W", "1M", "3M", "6M", "YTD", "1Y", "3Y", "5Y", "10Y", "20Y"],
      defaultType: ["general", "LTF", "RMF"],
      type: [
        {
          value: "general",
          title: "ทั่วไป",
          checked: true
        },
        {
          value: "LTF",
          title: "LTF",
          checked: true
        },
        {
          value: "RMF",
          title: "RMF",
          checked: true
        }
      ],
      defaultDividend: ["paid", "unpaid"],
      dividend: [
        {
          value: "paid",
          title: "จ่าย",
          checked: true
        },
        {
          value: "unpaid",
          title: "ไม่จ่าย",
          checked: true
        }
      ],
      isFilter: false
    }
  },
  computed: {
    ...mapGetters("fund", ["getFundCategories", "getFundAmc", "getFundFilter"])
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (from && from.path === "/miniapp/ltf-rmf") {
          this.objQuery = {}
          this.defaultCategory = ""
        }
        if (from && from.path === "/miniapp/market/gold") {
          this.objQuery = {}
          this.defaultCategory = ""
        }
        this.genQuery()
      }
    }
  },
  async created() {
    window.addEventListener("scroll", this.handleScroll)
    window.scroll(0, 0)
    await this.findFundAmc()
    await this.findFundCategories()
    this.genQuery()
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    ...mapActions("fund", ["findFundAmc", "findFundCategories"]),
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      currentScrollPosition > 73 ? (this.shouldStick = true) : (this.shouldStick = false)
      this.$emit("current-scroll", currentScrollPosition)
    },
    async resetFilter() {
      this.arrFilterTags = {}
      this.filterTagsShow = {}
      delete this.objQuery.category
      delete this.objQuery.amc
      delete this.objQuery.dividend
      delete this.objQuery.type

      this.prepareObjQuery = {}
      this.defaultCategory = ""
      this.defaultAmc = ""
      this.defaultDividend = ["paid", "unpaid"]
      this.defaultType = ["general", "LTF", "RMF"]

      await this.mixins_global_getFundFilter(this.objQuery)
      this.$router.replace({ name: "miniapp-market-fund" })
    },
    generateText(txt) {
      switch (txt) {
        case "general":
          return "ทั่วไป"
        case "LTF":
          return "LTF"
        case "RMF":
          return "RMF"
        case "paid":
          return "จ่ายปันผล"
        case "unpaid":
          return "ไม่จ่ายปันผล"
        default:
          return ""
      }
    },
    async submitFilter() {
      document.documentElement.style.overflow = "auto"
      this.filterTagsShow = this.arrFilterTags
      this.objQuery = this.prepareObjQuery
      await this.mixins_global_getFundFilter(this.objQuery)
      this.toggleFilter()
    },
    prepareQs(val, alias) {
      if (alias == "category") {
        if (val) {
          this.prepareObjQuery.category = val.value
        } else {
          delete this.prepareObjQuery.category
        }
        this.defaultCategory = val.value
      } else if (alias == "amc") {
        if (val) {
          this.prepareObjQuery.amc = val.value
          this.arrFilterTags.amc = [
            {
              title: val.title,
              value: val.value
            }
          ]
        } else {
          delete this.prepareObjQuery.amc
          delete this.arrFilterTags.amc
        }
        this.defaultAmc = val.value
      } else if (alias == "dividend") {
        if (val && val.length > 0) {
          const arrDividend = []
          for (let i = 0; i <= val.length - 1; i++) {
            if (val[i].checked == true) {
              arrDividend.push(val[i].value)
            }
          }
          if (arrDividend.length == 0) {
            this.prepareObjQuery.dividend = false
            delete this.arrFilterTags.dividend
          } else if (arrDividend.length == val.length) {
            delete this.prepareObjQuery.dividend
            delete this.arrFilterTags.dividend
          } else {
            this.prepareObjQuery.dividend = arrDividend
            this.arrFilterTags.dividend = this.prepareObjQuery.dividend
          }

          if (this.prepareObjQuery.dividend) {
            this.defaultDividend = this.prepareObjQuery.dividend
          } else {
            this.defaultDividend = []
          }
        }
      } else if (alias == "type") {
        if (val && val.length > 0) {
          const arrType = []
          for (let i = 0; i <= val.length - 1; i++) {
            if (val[i].checked == true) {
              arrType.push(val[i].value)
            }
          }
          if (arrType.length == 0) {
            this.prepareObjQuery.type = false
            delete this.arrFilterTags.type
          } else if (arrType.length == val.length) {
            delete this.prepareObjQuery.type
            delete this.arrFilterTags.type
          } else {
            this.prepareObjQuery.type = arrType
            this.arrFilterTags.type = this.prepareObjQuery.type
          }

          if (this.prepareObjQuery.type) {
            this.defaultType = this.objQuery.type
          } else {
            this.defaultType = []
          }
        }
      }
    },
    async insertQs(val, alias) {
      if (alias == "category") {
        if (val) {
          this.objQuery.category = val.value
        } else {
          delete this.objQuery.category
        }
        this.defaultCategory = val.value
      } else if (alias == "amc") {
        if (val) {
          this.objQuery.amc = val.value
        } else {
          delete this.objQuery.amc
        }
        this.defaultAmc = val.value
      } else if (alias == "dividend") {
        if (val && val.length > 0) {
          const arrDividend = []
          for (let i = 0; i <= val.length - 1; i++) {
            if (val[i].checked == true) {
              arrDividend.push(val[i].value)
            }
          }
          if (arrDividend.length == 0) {
            this.objQuery.dividend = false
          } else if (arrDividend.length == val.length) {
            delete this.objQuery.dividend
          } else {
            this.objQuery.dividend = arrDividend
          }

          if (this.objQuery.dividend) {
            this.defaultDividend = this.objQuery.dividend
          } else {
            this.defaultDividend = []
          }
        }
      } else if (alias == "page") {
        this.objQuery.page = val
      } else if (alias == "period") {
        this.objQuery.period = val
        this.defaultPeriod = val
      } else if (alias == "page") {
        this.objQuery.page = val
      } else if (alias == "size") {
        this.objQuery.size = val
      } else if (alias == "type") {
        if (val && val.length > 0) {
          const arrType = []
          for (let i = 0; i <= val.length - 1; i++) {
            if (val[i].checked == true) {
              arrType.push(val[i].value)
            }
          }
          if (arrType.length == 0) this.objQuery.type = false
          else if (arrType.length == val.length) {
            delete this.objQuery.type
          } else this.objQuery.type = arrType

          if (this.objQuery.type) {
            this.defaultType = this.objQuery.type
          } else {
            this.defaultType = []
          }
        }
      }
      await this.mixins_global_getFundFilter(this.objQuery)
    },
    genQuery() {
      if (this.$route.query.period) {
        this.objQuery.period = this.$route.query.period.toUpperCase()
        this.defaultPeriod = this.$route.query.period.toUpperCase()
      }
      if (this.$route.query.type) {
        if (!Array.isArray(this.$route.query.type)) {
          this.objQuery.type = [this.$route.query.type]
          this.defaultType = [this.$route.query.type]
          this.arrFilterTags.type = [this.$route.query.type]
          this.filterTagsShow.type = [this.$route.query.type]
        } else {
          this.objQuery.type = this.$route.query.type
          this.defaultType = this.$route.query.type
          this.arrFilterTags.type = this.$route.query.type
          this.filterTagsShow.type = this.$route.query.type
        }
      }

      if (this.$route.query.amc) {
        this.objQuery.amc = this.$route.query.amc
        this.defaultAmc = this.$route.query.amc
        this.arrFilterTags.amc = this.$route.query.amc
        this.filterTagsShow.amc = this.$route.query.amc
      }

      if (this.$route.query.dividend) {
        if (!Array.isArray(this.$route.query.dividend)) {
          this.objQuery.dividend = [this.$route.query.dividend]
          this.defaultDividend = [this.$route.query.dividend]
          this.arrFilterTags.dividend = [this.$route.query.dividend]
          this.filterTagsShow.dividend = [this.$route.query.dividend]
        } else {
          this.objQuery.dividend = this.$route.query.dividend
          this.defaultDividend = this.$route.query.dividend
          this.arrFilterTags.dividend = this.$route.query.dividend
          this.filterTagsShow.dividend = this.$route.query.dividend
        }
      }

      if (this.$route.query.category) {
        this.objQuery.category = this.$route.query.category
        this.defaultCategory = this.$route.query.category
      }

      this.objQuery.size = 20
      this.mixins_global_getFundFilter(this.objQuery)
    },
    toggleFilter() {
      if (this.isFilter) {
        this.isFilter = false
      } else {
        this.isFilter = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#article-fund-ranking {
  position: relative;
  h2 {
    @extend %font-size-m;
    font-weight: bold;
    margin-bottom: 10px;
    color: $color-normal-text;
  }
  #section-filter-fund {
    margin: 12px 15px;
    .filter-left {
      @include finCol(10, 12, 8px, middle, true, false);
    }
    .filter-right {
      @include finCol(2, 12, 8px, middle, false, true);
    }
    .filter-ctn {
      border-radius: 6px;
      background-color: #efefef;
      padding: 13.5px 16px;
      display: block;
      text-align: center;
      color: $color-normal-text;
      font-size: 12px;
      box-shadow: 0 0 4px 0 #f9f9f9;
      @media screen and (min-width: 480px) {
        min-height: 53px;
      }
      .filtered {
        color: $color-orange-finno;
      }
    }
  }
  #section-filter-tags {
    position: relative;
    margin-bottom: 12px;
    .filter-tags-box {
      display: flex;
      align-items: center;
      border-radius: 21.5px;
      background-color: #f9f9f9;
      padding: 4px 48px 4px 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .tags-label {
        display: inline-block;
        @extend %font-size-s;
        font-weight: bold;
        margin-right: 10px;
      }
      .tags-list {
        list-style: none;
        margin: 0;
        padding: 0;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        .tags-item {
          display: inline;
          @extend %font-size-s;
          color: $color-normal-text;
          &:not(:last-child) {
            &:after {
              content: ",";
              width: 5px;
              height: 5px;
              margin-right: 10px;
            }
          }
        }
      }
    }
    .reset-filter {
      position: absolute;
      right: 25px;
      top: 5px;
      i {
        pointer-events: none;
        color: $color-light-grey-2;
      }
    }
  }
  #list-fund {
    padding-right: 0px;
    padding-left: 0px;
  }
}
.select-period-row {
  padding-left: 0;
  padding-right: 0;
}
.top-sticky {
  left: 0 !important;
  width: 100% !important;
  .select-period-row {
    padding-top: 49px;
  }
}
.filter-row {
  display: inline-block;
  margin: 12px 0;
  width: 100%;
  h4 {
    @extend %font-size-m;
    font-weight: bold;
  }
}
.filter-submit {
  margin-top: 48px;
  text-align: center;
  .ctn-filter {
    border-radius: 4px;
    padding: 11px 45px;
    text-decoration: none;
    font-weight: bold;
    @include finRippleBtn(#f4f4f4, #f4f4f4, $color-normal-text);
  }
}
</style>